<button #trigger="cdkOverlayOrigin"
        cdkOverlayOrigin
        type="button"
        class="status-pill"
        (click)="toggle()">
  <span class="status-dot"
        [style.background-color]="current().color"></span>
  <span class="status-label">{{ current().labelKey | translate }}</span>
  <mat-icon class="status-chevron">expand_more</mat-icon>
</button>

<ng-template cdkConnectedOverlay
             [cdkConnectedOverlayOrigin]="trigger"
             [cdkConnectedOverlayOpen]="open()"
             [cdkConnectedOverlayHasBackdrop]="true"
             cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
             (backdropClick)="close()"
             (detach)="close()">
  <div class="status-menu">
    @for (option of options; track option.value) {
    <button type="button"
            class="status-option"
            (click)="select(option.value)">
      <span class="status-dot"
            [style.background-color]="option.color"></span>
      <span class="status-option-label">{{ option.labelKey | translate }}</span>
      @if (option.value === status()) {
      <mat-icon class="status-check">check</mat-icon>
      }
    </button>
    }
  </div>
</ng-template>
